export const valueCards = [
  {
    title: "Curated Experiences",
    body: "Every Aura event is designed with a clear purpose, audience, flow, and outcome.",
    icon: "Sparkles",
  },
  {
    title: "Meaningful Connections",
    body: "We bring together people, professionals, creators, teams, and communities around shared interests.",
    icon: "HeartHandshake",
  },
  {
    title: "Practical Takeaways",
    body: "Our events are built to offer useful insights, tools, habits, frameworks, or conversations.",
    icon: "Compass",
  },
  {
    title: "Scalable Event Tracks",
    body: "From wellness workshops to tech meetups and cultural experiences, Aura is designed to grow across genres.",
    icon: "Layers",
  },
];

export const wellnessPillars = [
  {
    title: "Smart Nutrition",
    body: "Simple food choices, meal timing, balanced plates, hydration, and realistic planning for busy workdays.",
  },
  {
    title: "Sustainable Movement",
    body: "Desk-friendly mobility, beginner exercise routines, posture awareness, and movement habits that fit professional schedules.",
  },
  {
    title: "Mental Relaxation",
    body: "Breathing, mindfulness, reflection, relaxation techniques, and guided stress-reset practices.",
  },
  {
    title: "Lifestyle Systems",
    body: "Habit design, sleep routines, digital boundaries, weekly planning, and better daily rhythm.",
  },
  {
    title: "Workplace Wellness",
    body: "Custom wellness sessions for companies, hybrid teams, offsites, and employee engagement programs.",
  },
];

export const useCases = [
  {
    title: "Corporate Wellness",
    body: "Nutrition, movement, relaxation, and habit-building events for employees and teams.",
  },
  {
    title: "Team Engagement",
    body: "Curated sessions for offsites, employee engagement days, retreats, and hybrid teams.",
  },
  {
    title: "Tech & Learning Sessions",
    body: "AI workshops, product talks, founder sessions, and professional learning events.",
  },
  {
    title: "Community Experiences",
    body: "Networking evenings, interest-based meetups, creative gatherings, and cultural sessions.",
  },
  {
    title: "Brand Collaborations",
    body: "Co-created events with brands, facilitators, experts, venues, and community partners.",
  },
];

export const steps = [
  {
    n: "01",
    title: "Choose the event track",
    body: "Select from wellness, technology, business, creativity, learning, community, or a custom theme.",
  },
  {
    n: "02",
    title: "Define the audience",
    body: "We design around the people attending — professionals, employees, founders, creators, students, or communities.",
  },
  {
    n: "03",
    title: "Curate the experience",
    body: "Aura plans the format, flow, speakers, facilitators, activities, and takeaways.",
  },
  {
    n: "04",
    title: "Deliver and grow",
    body: "Events are designed to create value during the session and momentum after it ends.",
  },
];

export const agenda = [
  { range: "0 – 10 min", title: "Welcome, context, and audience check-in" },
  { range: "10 – 30 min", title: "Expert-led insight or guided activity" },
  { range: "30 – 55 min", title: "Interactive workshop, discussion, or group experience" },
  { range: "55 – 70 min", title: "Practical takeaway, framework, or action planning" },
  { range: "70 – 85 min", title: "Q&A, reflection, or networking" },
  { range: "85 – 90 min", title: "Closing, next steps, and community invitation" },
];

export const partnerCards = [
  {
    title: "Speakers & Experts",
    body: "For professionals who want to lead sessions, panels, workshops, or conversations.",
  },
  {
    title: "Facilitators & Trainers",
    body: "For wellness coaches, nutrition specialists, movement coaches, mindfulness facilitators, tech trainers, and learning experts.",
  },
  {
    title: "Brands & Sponsors",
    body: "For brands that want to connect with thoughtful, engaged audiences.",
  },
  {
    title: "Venues & Communities",
    body: "For spaces and communities interested in co-hosting meaningful experiences.",
  },
];

export const audienceCards = [
  { title: "Working professionals" },
  { title: "Corporate teams" },
  { title: "Founders and creators" },
  { title: "HR and people teams" },
  { title: "Learners and career builders" },
  { title: "Communities and clubs" },
  { title: "Brands and partners" },
];

export const testimonials = [
  {
    quote: "An event that feels useful, calm, and thoughtfully designed.",
    role: "Sample placeholder",
  },
  {
    quote: "A space to learn, meet people, and leave with practical takeaways.",
    role: "Sample placeholder",
  },
  {
    quote: "More than an event — a curated experience with real value.",
    role: "Sample placeholder",
  },
];
